"use strict";

var _objectSpread = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _objectWithoutProperties = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _taggedTemplateLiteral = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _nullishCoalesce(lhs, rhsFn) {
  if (lhs != null) {
    return lhs;
  } else {
    return rhsFn();
  }
}

var _chunkFKBTJYRFjs = require('./chunk-FKBTJYRF.js');

var _chunkNESC3UD7js = require('./chunk-NESC3UD7.js');

var _chunk6R5OOOHCjs = require('./chunk-6R5OOOHC.js');

var _react = require('react');

var _styledcomponents = require('styled-components');

var _styledcomponents2 = _interopRequireDefault(_styledcomponents);

var _jsxruntime = require('react/jsx-runtime');

var S = _styledcomponents.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin: 0;\n    padding: 0;\n    margin-block-start: 0;\n    margin-block-end: 0;\n    margin-inline-start: 0;\n    margin-inline-end: 0;\n"]))),
    g = _styledcomponents2.default.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n\n    ", ";\n\n    /* Placing here to give priority over other styles */\n    ", "\n"])), S, function (_ref) {
  var o = _ref.$color,
      e = _ref.theme;
  return e.color.text[o];
}, function (_ref2) {
  var o = _ref2.$forceMobile,
      e = _ref2.$typographySpecKey,
      r = _ref2.theme;
  return _chunkFKBTJYRFjs.a.call(void 0, {
    $forceMobile: o,
    $typographySpecKey: e,
    theme: r
  });
}, _chunkNESC3UD7js.e);

function F(o) {
  var e = _chunk6R5OOOHCjs.g.call(void 0, o.name),
      t = _react.forwardRef.call(void 0, function (_ref3, m) {
    var _ref3$as = _ref3.as,
        i = _ref3$as === void 0 ? o.as : _ref3$as,
        a = _ref3.color,
        _ref3$dataTestid = _ref3["data-testid"],
        y = _ref3$dataTestid === void 0 ? e : _ref3$dataTestid,
        x = _ref3.forceMobile,
        C = _ref3.IGNORECHECKS,
        T = _objectWithoutProperties(_ref3, ["as", "color", "data-testid", "forceMobile", "IGNORECHECKS"]);

    return _jsxruntime.jsx.call(void 0, g, _objectSpread({
      $color: _nullishCoalesce(_chunk6R5OOOHCjs.b.call(void 0, o.colorOptions, o.name, a, "text", C), function () {
        return o.colorOptions[0];
      }),
      $forceMobile: x,
      $typographySpecKey: o.typographySpecKey,
      as: i,
      "data-testid": y,
      ref: m
    }, T));
  });

  return t.displayName = o.name, t.colorOptions = o.colorOptions, t.typographySpecKey = o.typographySpecKey, t.hasMobileStyles = !!o.hasMobileStyles, t;
}

exports.a = S;
exports.b = F;